export default __webpack_public_path__ + "static/media/gallery - levicorpus_00.153e2a80.jpg";